// @ts-ignore
import cookies from 'react-cookies';
import callRequest from '@stelecom/ui-react/components/requests/callRequestIntegration';
import { IRequestByConnectionParam } from '~/src/api/service-request/request-by-connection';
import { EProductsId } from '~/src/constants';

const MailDevices: Record<string, string> = {
    '101183': 'Приставка Movix Pro Voice',
};

const MailProducts: Record<EProductsId, string> = {
    [EProductsId.internet]: 'Интернет',
    [EProductsId.tv]: 'ТВ',
    [EProductsId.telephony]: 'Телефония',
    [EProductsId.tvAndInternet]: 'ТВ и интернет',
    [EProductsId.content]: 'Контент',
    [EProductsId.intercom]: 'Домофония',
    [EProductsId.videocontrol]: 'Видеоконтроль',
};

interface IMailRequestByCallParam {
    phone: string;
    fio: string;
    checkCallType?: string;
    product?: string;
    purchaseOption?: string;
    comment?: string;
}

export interface IRequestByConnectionResult {
    status: number,
    message: string,
    code: number,
}

export const getIMailRequestByCallParamFromIRequestByConnectionParam =
    (data: IRequestByConnectionParam | FormData): IMailRequestByCallParam => {
        const isFormData = data instanceof FormData;

        const mailParams: IMailRequestByCallParam = {
            fio: '',
            phone: '',
            product: '',
        };

        let deviceId: string;
        let productId: EProductsId;
        let tvEquipmentBuy: string;
        let tvEquipmentDuration: number | undefined;
        let costType: number;
        let leasingDuration: number;
        let comment: string;

        if (isFormData) {
            mailParams.checkCallType = (data as FormData).get('check_call_type')?.toString() || '';
            mailParams.fio = (data as FormData).get('fio')?.toString() || 'Не указано';
            mailParams.phone = (data as FormData).get('phone')?.toString() || 'Не указано';
            comment = (data as FormData).get('prim')?.toString() || '';

            deviceId = (data as FormData).get('tv_equipment_id')?.toString() || '';
            productId = ((data as FormData).get('product_id')?.toString() || EProductsId.intercom) as EProductsId;
            tvEquipmentBuy = (data as FormData).get('tv_equipment_buy')?.toString() || '';
            tvEquipmentDuration = parseInt((data as FormData).get('tv_equipment_duration')?.toString() || '0');
            costType = parseInt((data as FormData).get('cost_type')?.toString() || '0');
            leasingDuration = parseInt((data as FormData).get('leasing_duration')?.toString() || '0');
        } else {
            mailParams.checkCallType = (data as IRequestByConnectionParam).check_call_type;
            mailParams.fio = (data as IRequestByConnectionParam).fio;
            mailParams.phone = (data as IRequestByConnectionParam).phone;
            comment = (data as IRequestByConnectionParam).prim || '';

            const tv_equipment_id: number | number[] | undefined = (data as IRequestByConnectionParam).tv_equipment_id;

            deviceId = typeof tv_equipment_id === 'number'
                ? tv_equipment_id.toString()
                : '';

            tvEquipmentBuy = (data as IRequestByConnectionParam).tv_equipment_buy?.toString() || '';
            tvEquipmentDuration = (data as IRequestByConnectionParam).tv_equipment_duration || 0;
            costType = (data as IRequestByConnectionParam).cost_type || 0;
            leasingDuration = (data as IRequestByConnectionParam).leasing_duration || 0;
            productId = (data as IRequestByConnectionParam).product_id;
        }

        if (costType || leasingDuration) {
            if (leasingDuration) {
                mailParams.purchaseOption = `рассрочка на ${leasingDuration} мес.`;
            } else {
                mailParams.purchaseOption = 'покупка в собственность';
            }
        } else {
            switch (tvEquipmentBuy) {
                case 'leasing':
                    mailParams.purchaseOption = `рассрочка на ${tvEquipmentDuration} мес.`;
                    break;

                case 'sale':
                    mailParams.purchaseOption = 'покупка в собственность';
                    break;

                default:
                    mailParams.purchaseOption = '';
                    break;
            }
        }

        mailParams.product += MailProducts[productId]
            ? `Услуга: '${MailProducts[productId]}'.`
            : '';

        mailParams.product += MailDevices[deviceId]
            ? ` Оборудование: '${MailDevices[deviceId]}'.`
            : '';

        mailParams.product += comment;

        return mailParams;
    };

export const sendMailRequestByCall = async(
    cityDomain: string,
    data: IMailRequestByCallParam,
): Promise<IRequestByConnectionResult> => {
    const resp = await callRequest(process.env.ENVIROMENT === 'production' ? 'stelecom' : 'rinet').post(
        '/user/mail-request-by-call',
        data,
        {
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Domain': cityDomain || cookies.load('citydomain'),
            },
        },
    );

    return resp.data;
};
